<ngx-spinner [name]="name" [bdColor]="background" size="medium" color="#EA0639" type="line-scale-pulse-out"
  [fullScreen]="fullScreen">
  <p *ngIf="title" class="title">{{ title }}</p>
  <p *ngIf="subtitle" class="subtitle">{{ subtitle }}</p>
  <p *ngIf="text" class="loading newlines">{{ text }}</p>
</ngx-spinner>
